'use strict'
module.exports = {
  LOG: 'log',
  BROWSER: 'browser',
  AGENT: 'agent'
}
